
import Course from "../../components/Course/Course";
import WhatsAppRedirect from "../../components/Whatsapp/Whatsapp";

const Courses = () => {
  return (
    <div className="mt-5">
      <Course />
      <div className="fixed bottom-8 right-8">
        <WhatsAppRedirect />
      </div>
    </div>
  );
};

export default Courses;
